<template>
  <commonAnnouncementDetail
    :pageData="pageData"
    :currBreadCrumb="currBreadCrumb"
    :fileData="fileData"
    :source="source"
    :publishedBy="publishedBy"
  ></commonAnnouncementDetail>
</template>

<script>
import { getArgs } from "@/basa/utils";
import {
  // qryNoticeDetail,
  selectPulicBidNoticeDetail,
  qryWorkDynamicsDetail
} from "@/app/shop/api/shopping";
import { announcementPageSource } from "@/setting/setting";
import commonAnnouncementDetail from "@/app/shop/components/commonAnnouncementDetail.vue";
export default {
  name: "questionOrManualDetail",
  components: {
    commonAnnouncementDetail
  },
  data() {
    return {
      pageData: {},
      currBreadCrumb: [],
      fileData: [],
      source: this.$route.query.source,
      publishedBy: this.$route.query.publishedBy,
      interfaceType: this.$route.query.interfaceType
    };
  },
  activated() {
    this.currBreadCrumb = [];
    this.currBreadCrumb.push({
      title: "",
      path: `/announcementsList?source=${this.source}&interfaceType=${
        this.interfaceType
      }&type=${this.source === "-1" ? "0" : "1"}`
    });
    if (
      this.source != "-1" &&
      this.source != "0" &&
      this.source != "1" &&
      this.source != "2" &&
      this.source != "3" &&
      this.source != "4" &&
      this.source != "5" &&
      this.source != "6"
    ) {
      this.currBreadCrumb.push({
        title: "",
        path:
          "/announcementsList?source=" +
          this.source +
          "&interfaceType=" +
          this.interfaceType
      });
    }
    switch (this.source) {
      case "-1":
        this.currBreadCrumb[0].title = "通知公告";
        break;
      case "0":
        this.currBreadCrumb[0].title = "工作动态";
        break;
      case "1":
        this.currBreadCrumb[0].title = "价格指导";
        break;
      case "2":
        this.currBreadCrumb[0].title = "采购公告";
        break;
      case "3":
        this.currBreadCrumb[0].title = "评标公示";
        break;
      case "4":
        this.currBreadCrumb[0].title = "行业要闻";
        break;
      case "5":
        this.currBreadCrumb[0].title = "市场行情";
        break;
      case "6":
        this.currBreadCrumb[0].title = "分析报告";
        break;
      case "10":
        this.currBreadCrumb[0].title = "采购招标";
        this.currBreadCrumb[1].title = "采购公告";
        break;
      case "11":
        this.currBreadCrumb[0].title = "采购招标";
        this.currBreadCrumb[1].title = "评标公示";
        break;
      case "12":
        this.currBreadCrumb[0].title = "集采展示专栏";
        this.currBreadCrumb[1].title = "集采成果";
        break;
      case "13":
        this.currBreadCrumb[0].title = "集采展示专栏";
        this.currBreadCrumb[1].title = "集采方案";
        break;
      case "14":
        this.currBreadCrumb[0].title = "集采展示专栏";
        this.currBreadCrumb[1].title = "集采框架协议";
        break;
      case "15":
        this.currBreadCrumb[0].title = "集采展示专栏";
        this.currBreadCrumb[1].title = "物资集采目录";
        break;
      case "16":
        this.currBreadCrumb[0].title = "集采展示专栏";
        this.currBreadCrumb[1].title = "集采专家成员名单";
        break;
      case "17":
        this.currBreadCrumb[0].title = "集采展示专栏";
        this.currBreadCrumb[1].title = "采购管理制度";
        break;
      case "18":
        this.currBreadCrumb[0].title = "集采展示专栏";
        this.currBreadCrumb[1].title = "示范文本";
        break;
      case "19":
        this.currBreadCrumb[0].title = "集采展示专栏";
        this.currBreadCrumb[1].title = "内贸企业信息";
        break;
      case "20":
        this.currBreadCrumb[0].title = "集采展示专栏";
        this.currBreadCrumb[1].title = "获奖情况";
        break;
      case "30":
        this.currBreadCrumb[0].title = "市场动态";
        this.currBreadCrumb[1].title = "行业新闻";
        break;
      case "31":
        this.currBreadCrumb[0].title = "市场动态";
        this.currBreadCrumb[1].title = "市场行情";
        break;
      case "32":
        this.currBreadCrumb[0].title = "市场动态";
        this.currBreadCrumb[1].title = "价格信息";
        break;
      case "33":
        this.currBreadCrumb[0].title = "市场动态";
        this.currBreadCrumb[1].title = "分析报告";
        break;
      case "27":
        this.currBreadCrumb[0].title = "市场动态";
        this.currBreadCrumb[1].title = "行业网站";
        break;
      case "22":
        this.currBreadCrumb[0].title = "规章制度";
        this.currBreadCrumb[1].title = "政策法规";
        break;
      case "23":
        this.currBreadCrumb[0].title = "规章制度";
        this.currBreadCrumb[1].title = "制度流程";
        break;
      case "24":
        this.currBreadCrumb[0].title = "规章制度";
        this.currBreadCrumb[1].title = "合同范本";
        break;
      case "25":
        this.currBreadCrumb[0].title = "规章制度";
        this.currBreadCrumb[1].title = "知识管理";
        break;
      case "26":
        this.currBreadCrumb[0].title = "管理体系";
        break;
      default:
        this.currBreadCrumb[0].title = "通知公告";
        break;
    }
    this.init();
  },
  deactivated() {
    this.currBreadCrumb = [];
  },
  computed: {},
  methods: {
    init() {
      console.log(this.source === announcementPageSource.overseasZone);
      // if (
      //   this.source === announcementPageSource.evaluationResults ||
      //   this.source === announcementPageSource.purchaseAnnouncement ||
      //   this.source === announcementPageSource.overseasZone ||
      //   this.source === announcementPageSource.JCCG ||
      //   this.source === announcementPageSource.JGFA ||
      //   this.source === announcementPageSource.JCKJXY ||
      //   this.source === announcementPageSource.WZJCML ||
      //   this.source === announcementPageSource.JCZJCYMD ||
      //   this.source === announcementPageSource.CGGLZD ||
      //   this.source === announcementPageSource.SFWB ||
      //   this.source === announcementPageSource.NMQYXX ||
      //   this.source === announcementPageSource.HJQK ||
      //   this.source === announcementPageSource.JTGYSML ||
      //   this.source === announcementPageSource.ZCFG ||
      //   this.source === announcementPageSource.ZDLC ||
      //   this.source === announcementPageSource.HTFB ||
      //   this.source === announcementPageSource.ZSGL ||
      //   this.source === announcementPageSource.GLTX ||
      //   this.source === announcementPageSource.HYXW ||
      //   this.source === announcementPageSource.SCHQ ||
      //   this.source === announcementPageSource.JGXX ||
      //   this.source === announcementPageSource.FXBG ||
      //   this.source === announcementPageSource.HYWZ ||
      //   this.source === announcementPageSource.GYLGLBZJLXX
      // ) {
      //调用公告查详情接口
      // qryNoticeDetail({
      //   schemeId: this.$route.query.schemeId,
      //   noticeId: this.$route.query.id,
      //   qryFileFlag: true
      // }).then(res => {
      //   if (res.data.code === "0") {
      //     this.pageData = {
      //       title: res.data.data.noticeTitle,
      //       author: res.data.data.createName,
      //       publishTime: res.data.data.noticeStartTime,
      //       textContent: res.data.data.textInfo
      //     };
      //     this.fileData = res.data.data.fileinfoBOS;
      //     this.currBreadCrumb.push({ title: this.pageData.title });
      //   }
      // });
      if (this.source === "0" || this.source === "-1") {
        qryWorkDynamicsDetail({
          id: this.$route.query.id,
          isShowLoading: true
        }).then(res => {
          if (res.data.code === "0") {
            this.pageData = {
              source: res.data.data.sourceFrom,
              title: res.data.data.title,
              author: res.data.data.author,
              publishTime: res.data.data.updateTime,
              textContent: res.data.data.textContent,
              publishedBy: res.data.data.publishedBy
            };
            this.fileData = res.data.data.fileList;
            if (this.fileData.length > 0) {
              this.fileData.forEach(item => {
                item.fileSumm = item.fileDesc || item.fileSumm;
              });
            }
            // this.fileData = res.data.data.basFileRelationBOs.map(item => {
            //   item.uploadId = item.fileInfoId;
            //   item.fileSize = Math.round(item.fileSize / 1024);
            //   return item;
            // });

            // 新入口的删除多余面包屑
            const idsStr = getArgs("ids");
            if (idsStr) {
              this.currBreadCrumb = [];
            }
            this.currBreadCrumb.push({ title: this.pageData.title });
            console.log(this.currBreadCrumb, "currBreadCrumb");
          }
        });
      } else if (
        this.source === "2" ||
        this.source === "3" ||
        this.source === "10" ||
        this.source === "11" ||
        this.source === "12" ||
        this.source === "13" ||
        this.source === "14" ||
        this.source === "15" ||
        this.source === "16" ||
        this.source === "17" ||
        this.source === "18" ||
        this.source === "19" ||
        this.source === "20" ||
        this.source === "30" ||
        this.source === "31" ||
        this.source === "32" ||
        this.source === "33" ||
        this.source === "27" ||
        this.source === "22" ||
        this.source === "23" ||
        this.source === "24" ||
        this.source === "25" ||
        this.source === "26"
      ) {
        selectPulicBidNoticeDetail({
          noticeId: this.$route.query.noticeId,
          type: this.$route.query.type,
          isShowLoading: true
        }).then(res => {
          if (res.data.code === "0") {
            this.pageData = {
              source: res.data.data.source,
              title: res.data.data.noticeTitle,
              author: res.data.data.createName,
              publishTime: res.data.data.noticeStartTime.slice(0, -3),
              textContent: res.data.data.textInfo
            };
            this.fileData = res.data.data.basFileRelationBOs;
            this.fileData = res.data.data.basFileRelationBOs.map(item => {
              item.uploadId = item.fileInfoId;
              item.fileSize = Math.round(item.fileSize / 1024);
              return item;
            });
            this.currBreadCrumb.push({ title: this.pageData.title });
          }
        });
      } else if (
        this.source === "1" ||
        this.source === "4" ||
        this.source === "5" ||
        this.source === "6"
      ) {
        let detailInfo = JSON.parse(localStorage.detailInfo);
        this.pageData = {
          title: detailInfo.title,
          author: "",
          publishTime: detailInfo.pubdate,
          textContent: detailInfo.textInfo
        };
        this.fileData = [];
        this.currBreadCrumb.push({ title: detailInfo.title });
      }
      //  else {
      //   queryNoticeById({
      //     noticeInfoId: this.$route.query.id,
      //     isShowPageLoading: true,
      //     isShowLoading: true
      //   }).then(res => {
      //     if (res.data.code === "0") {
      //       this.pageData = res.data.data["noticeInfoBO"];
      //       this.fileData = res.data.data.basFileRelationBOs.map(item => {
      //         item.uploadId = item.fileInfoId;
      //         item.fileSize = Math.round(item.fileSize / 1024);
      //         return item;
      //       });
      //       this.currBreadCrumb.push({ title: this.pageData.title });
      //     }
      //   });
      // }
    }
  }
};
</script>

<style scoped></style>
